import MainLayout from 'Components/Layout/MainLayout';
import {Input, Menu, message, Spin} from 'antd';
import styles from './index.module.scss';
import {LinkButton} from 'Features/Buttons/LinkButton';
import Spacer from 'Components/Spacer';
import {
    ContainerOutlined,
    ExportOutlined,
    IssuesCloseOutlined,
    PlusSquareOutlined,
    UploadOutlined,
} from '@ant-design/icons';
import {DictTable} from './Components/DictTable';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import {DictModal} from './Components/DictModal';
import {DictListItem, exportDict, getDictList} from './service';
import {ItemType} from 'antd/lib/menu/hooks/useItems';
import React, {useMemo, useState} from 'react';
import {ImportDictModal} from './Components/ImportDictModal';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {errorMessage} from 'Utils/common';
import {useMount} from 'react-use';
import ImportLog from '../../../Components/ImportLog';
import {Auth} from '../../../Features/Auth';

export default function DictManage() {
    const [searchText, setSearchText] = useState('');
    const dictModal = useModalHandler({component: DictModal});
    const importDictModal = useModalHandler({component: ImportDictModal});

    const [refresh, {loading, data}] = useRequestFn(getDictList);

    // 默认选中第一个
    useMount(async () => {
        const data = await refresh();
        if (data.length !== 0) setCurrentId(data[0].id);
    });

    const [onExport, exportStatus] = useRequestFn(async () => {
        try {
            await exportDict();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const [currentId, setCurrentId] = useState<string>('');

    const current = useMemo(
        () => data?.find(item => item.id === currentId),
        [currentId, data],
    );

    async function onSaveOk() {
        dictModal.close();
        await refresh();
    }

    async function onImportOk() {
        importDictModal.close();
        await refresh();
    }

    function onAddNode(parentId: string) {
        dictModal.open({parentId, onOk: onSaveOk});
    }

    function onEdit(initialValues: DictListItem, isChild: boolean) {
        const parentId = isChild ? initialValues.parentId : undefined;
        dictModal.open({parentId, initialValues, onOk: onSaveOk});
    }

    function getMenuList(data: DictListItem[]): ItemType[] {
        const search = searchText.trim();
        return data
            ?.filter(item => item?.name?.includes(search))
            ?.map(item => ({
                label: `${item?.name} (${item?.childNumber || 0})`,
                key: item?.id,
                icon: <ContainerOutlined />,
                onClick: () => setCurrentId(item?.id),
                children: item?.children?.length
                    ? getMenuList(item?.children)
                    : undefined,
            }));
    }

    return (
        <MainLayout.SpaceWrapper className={styles.root} padding>
            <Spin spinning={loading} className={styles.spin}>
                <div className={styles.wrapper}>
                    <div className={styles.left}>
                        <div className={styles.leftHeader}>
                            <div className={styles.leftTop}>
                                <Auth code="SF_J476Zfxw11">
                                    <LinkButton
                                        onClick={() =>
                                            dictModal.open({onOk: onSaveOk})
                                        }>
                                        <PlusSquareOutlined />
                                        添加
                                    </LinkButton>
                                </Auth>

                                <Spacer />

                                <Auth code="SF_J476Zfxw20">
                                    <LinkButton
                                        title="导入"
                                        onClick={() =>
                                            importDictModal.open({
                                                onOk: onImportOk,
                                            })
                                        }>
                                        <UploadOutlined />
                                    </LinkButton>
                                </Auth>

                                <Auth code="SF_J476Zfxw21">
                                    <LinkButton
                                        title="导出"
                                        onClick={onExport}
                                        loading={exportStatus.loading}
                                        icon={<ExportOutlined />}
                                    />
                                </Auth>

                                <Auth code="SF_J476Zfxw22">
                                    <ImportLog
                                        logUrl="/dict/getImportErrorPage"
                                        downloadUrl="/dict/exportImportError">
                                        <LinkButton title="导入结果">
                                            <IssuesCloseOutlined />
                                        </LinkButton>
                                    </ImportLog>
                                </Auth>
                            </div>

                            <Input.Search
                                placeholder="请输入搜索内容"
                                onSearch={setSearchText}
                            />
                        </div>

                        <div className={styles.menu}>
                            <Menu
                                mode="inline"
                                selectedKeys={[currentId]}
                                items={getMenuList(data || [])}
                            />
                        </div>
                    </div>

                    <div className={styles.main}>
                        {current && (
                            <DictTable
                                key={current.key}
                                dict={current}
                                onEdit={(dict, isChild) =>
                                    onEdit(dict, isChild)
                                }
                                onAdd={() => onAddNode(current.id)}
                                onDictChange={refresh}
                            />
                        )}
                    </div>
                </div>
            </Spin>

            {dictModal.render()}
            {importDictModal.render()}
        </MainLayout.SpaceWrapper>
    );
}
